import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class LCDQueryClient {
  constructor({
    requestClient
  }) {
    _defineProperty(this, "req", void 0);
    this.req = requestClient;
    this.currentPlan = this.currentPlan.bind(this);
    this.appliedPlan = this.appliedPlan.bind(this);
    this.upgradedConsensusState = this.upgradedConsensusState.bind(this);
    this.moduleVersions = this.moduleVersions.bind(this);
  }
  /* CurrentPlan queries the current upgrade plan. */

  async currentPlan(_params = {}) {
    const endpoint = `cosmos/upgrade/v1beta1/current_plan`;
    return await this.req.get(endpoint);
  }
  /* AppliedPlan queries a previously applied upgrade plan by its name. */

  async appliedPlan(params) {
    const endpoint = `cosmos/upgrade/v1beta1/applied_plan/${params.name}`;
    return await this.req.get(endpoint);
  }
  /* UpgradedConsensusState queries the consensus state that will serve
   as a trusted kernel for the next version of this chain. It will only be
   stored at the last height of this chain.
   UpgradedConsensusState RPC not supported with legacy querier */

  async upgradedConsensusState(params) {
    const endpoint = `cosmos/upgrade/v1beta1/upgraded_consensus_state/${params.lastHeight}`;
    return await this.req.get(endpoint);
  }
  /* ModuleVersions queries the list of module versions from state. */

  async moduleVersions(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.moduleName) !== "undefined") {
      options.params.module_name = params.moduleName;
    }
    const endpoint = `cosmos/upgrade/v1beta1/module_versions`;
    return await this.req.get(endpoint, options);
  }
}